<template>
    <div class='h-full w-full flex items-center justify-center' v-if="!icon || example" >
        <img :src="example ? example : url" 
            @click="modalPreview" @error="error" 
            class="h-full w-full object-cover" 
            v-show='loaded'
            :onload='onLoad'
        />

        <ClientOnly>
            <Vue3Lottie :animationData="ZapoLogoJson" :height="40" :width="40" :loop="true" v-if="!loaded" />
        </ClientOnly>
    </div>

    <div v-else class="h-full w-full flex items-center">
        <div class='flex items-center flex-col'>
            <IconUpload class="stroke-green-600 w-6 h-6" /><!-- stroke-green-600 -->
            <p class="text-14 text-grey-900 text-center pt-2 max-w-[100%]">{{ fileNameShort }}</p>
        </div>
    </div>
</template>

<script>
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'

export default {
    props: {
        img: Object,
        example: [String, Boolean],
        type: String,
        noClick: { type: Boolean, default: false }
    },

    data() {
        return {
            icon: false,
            loaded: false,
            url: null,
            ZapoLogoJson
        }
    },

    created() {
        this.setUrl();
    },

    methods: {
        onLoad() {
            this.loaded = true
        },

        modalPreview() {
            if (this.noClick) {
                return false;
            }

            this.$event.$emit('modal-open', {
                view: 'OnboardingViewUploadedImage',
                editingModel: this.img,
                options: {
                    title: this.type ? this.type.replace('Upload your ', '').replace('Upload images of your ', '') + ' example' : '',
                },
            })
        },

        error(e) {
            console.log('has errored', this.url, this.url.indexOf('lp.getwork.uk'))

            // if (this.url.indexOf('lp.getwork.uk') != -1) {
                this.icon = true
            // } else {
            //     this.url = this.url.replace(useRuntimeConfig().public.landingPageURL, 'https://lp.getwork.uk')
            // }
        },

        setUrl() {
            if (this.img.url != undefined && this.img.url != null) {
                this.url = this.img.url;
                return;
            }

            this.url = useRuntimeConfig().public.landingPageURL + this.img.file_name.replace("public", "/storage");
        }
    },

    computed: {
        fileNameShort() {
            if (this.img.file_name.length <= 30) {
                return this.img.file_name
            }

            return this.img.file_name.slice(0, 22)
                +'...'
                + this.img.file_name.slice(-8)
        }
    },

    watch: {
        img() {
            this.loaded = false
        }
    }
}
</script>
